"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDashboardHighchartsOptionsProvider = void 0;
const highcharts_1 = __importDefault(require("highcharts"));
const lodash_1 = __importDefault(require("lodash"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const numbersDataForChartLastNIntervalData = (lastNIntervalData) => {
    const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(lastNIntervalData.intervalStartTimeSec * 1000).startOf("day");
    const numbersData = lodash_1.default.map(lastNIntervalData.data, (value, index) => {
        const day = initialMoment.clone().add(index, "day").startOf("day");
        const pointMillis = day.valueOf();
        return { x: pointMillis, y: value };
    });
    return numbersData;
};
const optionsForChartLastNIntervalData = (lastNIntervalData, params, chartStatus) => {
    if (!lastNIntervalData) {
        return { options: {}, chartStatus: chartStatus };
    }
    const numbersData = numbersDataForChartLastNIntervalData(lastNIntervalData);
    const title = params.chartTitle;
    const subTitle = params.chartSubTitle;
    const currentSeries = {
        type: "line",
        data: numbersData,
        name: params.seriesName,
        showInLegend: !lodash_1.default.isEmpty(params.seriesName),
    };
    const tooltip = {
        useHTML: false,
        formatter: function () {
            const point = this.point;
            const symbol = "<span style='color:" + point.series.color + "'>\u25CF</span>";
            const timestamp = new Date(this.x).getTime();
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, timestamp);
            return `<small>${date}</small><br/>${symbol}<b> ${point.y}</b>`;
        }
    };
    const yAxis = {
        title: undefined,
        min: 0,
        allowDecimals: false
    };
    return {
        options: {
            exporting: {
                filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
            },
            chart: { zoomType: "x", },
            title: { text: title },
            subtitle: { text: subTitle },
            series: [currentSeries],
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
                minTickInterval: 24 * 60 * 60 * 1000,
                startOnTick: false,
            },
            yAxis: yAxis,
            tooltip: tooltip,
        },
        chartStatus: chartStatus
    };
};
exports.ProjectDashboardHighchartsOptionsProvider = {
    optionsForChartLastNIntervalData: optionsForChartLastNIntervalData,
    numbersDataForChartLastNIntervalData: numbersDataForChartLastNIntervalData
};
